import React, { useContext } from 'react';
import Loadable from 'react-loadable';
import { CardLoading } from '../../utils/lightCards/cardLoading';
const MediaCardContext = /*#__PURE__*/React.createContext({});
const CardLoadingWithContext = () => {
  const props = useContext(MediaCardContext);
  return /*#__PURE__*/React.createElement(CardLoading, props);
};
const MediaCardWithMediaClientProvider = Loadable({
  loader: () => import( /* webpackChunkName: "@atlaskit-internal_media-card-with-media-client-v2" */'./cardWithMediaClientV2').then(mod => mod.CardWithMediaClientV2),
  loading: () => /*#__PURE__*/React.createElement(CardLoadingWithContext, null)
});
const CardLoader = props => {
  return /*#__PURE__*/React.createElement(MediaCardContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(MediaCardWithMediaClientProvider, props));
};
export default CardLoader;